import { EExpand } from '@r1-frontend/api-domru/api-content/_dto/tariff-lines-common-types';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

type IRequestDto = {
    restrictIgnore?: number,
    expand?: EExpand[],
}
;

/*
* Получения линейки тарифов по алиасу
* https://master.api-content.sandbox.d2c.r-one.io/docs/v1#/%D0%9B%D0%B8%D0%BD%D0%B5%D0%B9%D0%BA%D0%B8%20%D1%82%D0%B0%D1%80%D0%B8%D1%84%D0%BE%D0%B2/get_v1_tariff_lines__alias_
*/
const getTariffLineByAlias = ({ expand, restrictIgnore = 0 }: IRequestDto, alias: string): IRequest => ({
    uri: `/v1/tariff-lines/${alias}`,
    method: 'GET',
    withProvider: true,
    queryParams: {
        expand: expand?.join(','),
        restrictIgnore,
    },
});

export default getTariffLineByAlias;
